export const SHOPIFY_SCOPES = [
  'read_orders',
  'read_products',
  'write_themes',
  'read_themes',
  'read_customers',
  'read_fulfillments',
  'read_inventory',
];
